"use strict";
exports.__esModule = true;
exports.chart_pie_Height = {
  "name": "--pf-chart-pie--Height",
  "value": 230,
  "var": "var(--pf-chart-pie--Height, 230)"
};
exports["default"] = exports.chart_pie_Height;